import React from 'react'
import { Link } from 'react-router-dom'
import useDocumentTitle from '../../hooks/useDocumentTitle';

const NoPage = (props) => {
  useDocumentTitle(props.title);
  return (
    <>
      <div className="flex items-center justify-center h-screen">
        <div>
          <div className="flex flex-col items-center">
            <h1 className="font-bold text-3xl text-cherry-blossom lg:text-6xl">
              404
            </h1>

            <h6 className="mb-2 text-2xl font-bold text-center text-off-white md:text-3xl">
              <span className="text-red-500">Oops!</span> Page Not Found
            </h6>

            <p className="mb-4 text-center text-off-white md:text-lg">
              The page you’re looking for doesn’t exist.
            </p>

            <Link
              to="/v1"
              className="px-5 py-2 rounded-md text-off-white bg-indigo-600 hover:bg-indigo-700"
            >
              Go home
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default NoPage